"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldVisibilitySettings = void 0;
const AppContext_1 = require("../AppContext");
const cacheTimes_1 = require("../cacheTimes");
const FieldVisibilitySettings_1 = require("./FieldVisibilitySettings");
const FieldVisibilityContext_1 = require("./FieldVisibilityContext");
const react_query_1 = require("react-query");
const components_1 = require("../../components");
const apis_1 = require("../../apis");
const react_1 = require("react");
const useWhyDidYouUpdate_1 = require("../useWhyDidYouUpdate");
const axios_1 = __importDefault(require("axios"));
const react_2 = __importDefault(require("react"));
const emptyArray = [];
exports.useFieldVisibilitySettings = params => {
    const { app, containerId, settingsFromProps } = params;
    const { issueAlert } = components_1.useAlerts();
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("useFieldVisibilitySettings", params);
    const { apiClient: client } = react_1.useContext(AppContext_1.AppContext);
    const apiClient = apis_1.useApiClientWithGroupCorrelationId(client);
    const fetchFVS = react_1.useCallback((key, p) => FieldVisibilitySettings_1.fetchFieldVisibilitySettings({ ...p, apiClient, issueAlert }), [apiClient, issueAlert]);
    const emptyPromise = () => Promise.resolve(emptyArray);
    const { data, refetch: refresh, isFetching } = react_query_1.useQuery(["fvs", { app, containerId }], containerId ? fetchFVS : emptyPromise, {
        staleTime: cacheTimes_1.CacheTimes.TwentyFourHours // keep cached FVS for 24 hours since they're not updated that often
    });
    const defaultSettings = react_1.useMemo(() => ({
        app,
        containerId: containerId || "",
        components: settingsFromProps
            ? settingsFromProps.components
            : FieldVisibilitySettings_1.convertLegacyFieldVisibilitySettings(data || [])
    }), [app, data, containerId, settingsFromProps]);
    const { fieldVis, fieldVisDispatch } = FieldVisibilityContext_1.useFieldVisibilityContext(defaultSettings);
    const convertSettings = react_1.useCallback((settings) => settings.components.map(component => ({
        ...FieldVisibilitySettings_1.convertFieldToLegacyFormat(component),
        Id: component.Id,
        SectionName: containerId,
        Platform: app
    })), [containerId, app]);
    const uploadFieldVisibilitySettings = react_1.useCallback((newSettings) => {
        const newSettingsInLegacyFormat = newSettings
            ? convertSettings(newSettings)
            : [];
        const requests = containerId
            ? FieldVisibilitySettings_1.calculateRequests(newSettingsInLegacyFormat, data)
            : [];
        axios_1.default.all(requests.map(request => {
            if (request && request.id && request.data) {
                return FieldVisibilitySettings_1.patchFvs({
                    apiClient,
                    id: request.id,
                    diff: request.data
                });
            }
            else if (request && request.data) {
                return FieldVisibilitySettings_1.postFvs({
                    apiClient,
                    data: request.data
                });
            }
            return Promise.resolve(null);
        }))
            .then(result => {
            if (result && result.filter(r => !!r).length) {
                issueAlert({
                    header: "Success",
                    type: "success",
                    message: "FieldVisibilityUpdatedSuccessMessage"
                });
            }
            react_query_1.queryCache.invalidateQueries(["fvs", { app, containerId }], {
                exact: true
            });
        })
            .catch((error) => {
            issueAlert({
                header: "Error",
                type: "error",
                message: "FieldVisibilityUpdateErrorMessage"
            });
            issueAlert({
                type: "error",
                header: error.name,
                message: error.message,
                localize: false
            });
        });
    }, [apiClient, convertSettings, data, issueAlert, containerId, app]);
    const refetch = react_2.default.useCallback((args) => new Promise((resolve, reject) => {
        refresh(args)
            .then(legacy => {
            resolve({
                app,
                containerId: containerId || "",
                components: FieldVisibilitySettings_1.convertLegacyFieldVisibilitySettings(legacy || [])
            });
        })
            .catch(err => reject(err));
    }), [app, containerId, refresh]);
    return {
        fieldVis,
        refetch,
        fieldVisDispatch,
        uploadFieldVisibilitySettings,
        pending: isFetching
    };
};
//# sourceMappingURL=useFieldVisibilitySettings.js.map